import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AuthService } from "../shared/services/auth.service";

@Component({
  selector: 'app-person-modal',
  templateUrl: './person-modal.page.html',
  styleUrls: ['./person-modal.page.scss'],
})
export class PersonModalPage implements OnInit {
  @Input() personArray: string[];
  personName: string;
  user;
  userIndex: number = -1;
  disableAddMe = false;
  constructor(public modalController: ModalController, private auth: AuthService) {
    this.auth.getUserData().subscribe(u => {
      this.user = u;
    })
  }

  ngOnInit() {
    if (!this.personArray) {
      this.personArray = [];
    }
  }

  addPerson() {
    if (this.personName) {
      this.personArray.push(this.personName);
      this.personName = null;
    }
  }

  addMe() {
    this.personArray.push(this.user.displayName);
    this.userIndex = this.personArray.length - 1;
    this.disableAddMe = true;
    this.personName = null;
  }

  deletePerson(index) {
    this.personArray.splice(index, 1);
    if (index === this.userIndex) {
      this.disableAddMe = false;
      this.userIndex = -1;
    }
  }

  dismiss() {
    this.modalController.dismiss({
      persons: this.personArray
    });
  }

}
